module.exports = __webpack_public_path__ + "static/media/eye.548aa504.svg";